import { sleep } from "../helpers/functions";

export async function parseConnectionHTML(view, callback) {
	let isNewView = false;
	let children = view.querySelectorAll(
		".mn-connection-card__details .mn-connection-card__link, [data-view-name='connections-list']"
	);

	window._prsview = view;
	if(!children || children.length === 0){
		isNewView = true;
		children = view.querySelectorAll(":scope > div > div > a");
	}
	
	const findId = (element) => {
		if(isNewView){ return null; }

		const linkElement = element.querySelectorAll("div > a");
		const link = linkElement ? linkElement.href : element.href;
		const parts = link.split("/").filter((elm) => elm);
		return parts[parts.length - 1];
	};

	const findName = (element) => {
		const name = !isNewView ? element.querySelector(".mn-connection-card__name, a[data-view-name='connections-profile']:nth-child(1) p:nth-child(1) a"):
		element.querySelector(":scope div > a[componentkey] > div > p");
		
		return name ? name.textContent : ""
	}

	const findURL = (element) => {
		if(!isNewView){ return null; }
		const url = element.querySelector(':scope > div > a[componentkey]');
		
		return url ? url.href : ""
	}

	const buildItem = (element) => {
		return {
			id: findId(element),
			name: findName(element),
			url: findURL(element),
			isConnected: true,
		};
	};

	let item, isUpdated;
	const data = [];
	const childLength = children.length;
	const timeout = (2000 / childLength > 1) ? 2000 / childLength  : 0;
	for (let i = 0; i < children.length; i++) {
		item = isNewView ? buildItem(children[i].parentNode.parentNode) : buildItem(children[i]);
		children[i].remove();

		await sleep(timeout);        
		isUpdated = await callback(item);
		if (isUpdated) {
			data.push(item);
		}
	}
	console.log(data);
	return data;
}
